import React from 'react';
import { Button } from '../ui/button';
import { Check, UserPlus } from 'lucide-react';

/**
 * Post-completion panel that invites the guest to create a free account.
 */
export default function ThankYouPanel({ navigate }) {
  return (
    <div className="text-center py-4">
      <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-green-100 flex items-center justify-center">
        <Check className="w-6 h-6 text-green-600" />
      </div>
      <h4 className="font-medium mb-1">Thanks for sharing!</h4>
      <p className="text-sm text-muted-foreground mb-3">
        We&apos;d love to have you in our community.
      </p>
      <div className="space-y-2">
        <Button
          size="sm"
          className="w-full"
          onClick={() => navigate('/register')}
          data-testid="join-community-btn"
        >
          <UserPlus className="w-4 h-4 mr-2" />
          Join Free
        </Button>
        <p className="text-xs text-muted-foreground">
          Post, comment, add 1 pet & join events
        </p>
      </div>
    </div>
  );
}
